<template>
  <el-date-picker
    v-model="timeDate"
    :type="type"
    start-placeholder="立项开始日期"
    end-placeholder="立项结束日期"
    :placeholder="placeholder"
    :format="format"
    :value-format="valueFormat"
    :default-time="['00:00:00', '23:59:59']"
    :picker-options="pickerOptions"
  />
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "datetime"
    },
    format: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss"
    },
    valueFormat: {
      type: String,
      default: "yyyy-MM-dd HH:mm:ss"
    },
    placeholder: {
      type: String,
      default: "请选择发布日期和时间"
    },
    isMaxDate: {
      type: Boolean,
      default: false
    },
    isMinDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDueDate
      }
    };
  },
  computed: {
    timeDate: {
      get() {
        if (this.type === "daterange" || this.type === "datetimerange") {
          return this.value;
        } else if (this.value) {
          return new Date(this.value);
        } else {
          return this.value;
        }
      },
      set(val) {
        this.emitInput(val);
      }
    }
  },
  methods: {
    disabledDueDate(time) {
      if (this.isMaxDate) {
        return time.getTime() > Date.now(); // 只能选择今天及今天之前的日期
        // return time.getTime() > Date.now() - 8.64e7; //只能选择今天之前的日期，连今天的日期也不能选
      } else if (this.isMinDate) {
        return time.getTime() < Date.now() - 8.64e7; // 只能选择今天及以后的日期
      }
    },
    emitInput(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="less" scoped>
// ::v-deep .el-date-editor {
//   height: 36px;
//   .el-input__icon {
//     line-height: 30px;
//   }
//   // border-radius: 18px;
//   // background: rgba(236, 236, 236, 1);
//   // ::v-deep .el-range-input {
//   //   height: 36px;
//   //   background: rgba(236, 236, 236, 1);
//   //   border-radius: 18px;
//   //   border: none;
//   // }
// }
</style>
